import React from 'react';
import { Images, PermissionList, RolePermission } from 'utils';
import { SimpleTooltip, TextRow } from 'components';

export const domainHead = [
    { name: 'name', title: 'Domain Name', custom: false },
    { name: 'description', title: 'Description', custom: false },
    { name: 'type', title: 'Type', custom: false, disabled: true },
    { name: 'action', title: 'Action', custom: false, width: '100px' },
];

export const domainBody = [
    { rowText: (item) => <TextRow name={item?.name} /> },
    { rowText: (item) => <TextRow name={item?.description} /> },
    {
        rowText: (item) => (
            <div>
                {item?.system ? <div className="domain-table-system">System</div> : <div className="domain-table-custom">Custom</div>}
            </div>
        ),
    },
    RolePermission([PermissionList.DOMAIN_CREATE?.code]) && {
        button: (cb, item) =>
            item?.system ? (
                <SimpleTooltip title={'System domains cannot be edited or deleted'} placement="bottom" arrow>
                    <img src={Images.infoCircle} alt="flag" />
                </SimpleTooltip>
            ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img style={{ cursor: 'pointer', marginRight: '16px' }} src={Images.edit} alt="edit" onClick={() => cb('editDomain')} />
                    {/*<img*/}
                    {/*    style={{ cursor: 'pointer' }}*/}
                    {/*    src={Images.remove}*/}
                    {/*    alt="remove"*/}
                    {/*    onClick={() => cb('deleteDomain')}*/}
                    {/*/>*/}
                </div>
            ),
        notClickable: true,
    },
];

export const ACTION_TYPE = 'GET_DOMAINS';

export const domainNotYet = {
    title: 'No Domains Yet',
    subTitle: 'Start by adding your first Domain to manage their information.',
    image: Images.noClientYet,
};
